// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","title":"Card_title__A6GVy","tags":"Card_tags__Yu8oX","date":"Card_date__RtRbT","cover":"Card_cover__RMGfy","item":"Card_item__C00cL"};